module.exports = "/images/curvas-01.svg?7386b441060dcbfbc4f13402cbed6e02";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/curvas-01.svg
// module id = SRGQ
// module chunks = 0